.container {
  justify-content: flex-start;
  align-items: center;
  padding-top: 0;
}

.balanceCardsGrid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}

@media (max-width: 768px) {
  .balanceCardsGrid {
    flex-direction: column;
  }
}

/* The way on to the dealer cabinet while it loads (app#370); a link's target is 44px high. */
.cabinetLink {
  display: inline-flex;
  align-items: center;
  min-height: var(--gac-control-touch-target);
  color: var(--gac-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}
